import { useState, useEffect } from "react";
import GridIndex from "../../../components/GridIndex";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddCircleOutline";
import moment from "moment";
import axios from "../../../services/Api";
import useBreadcrumbs from "../../../hooks/useBreadcrumbs";
import { convertToDateandTime } from "../../../utils/Utils";
import { maskMobile } from "../../../utils/MaskData";

function AttendServiceTransportRendorIndex() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const setCrumbs = useBreadcrumbs();
  const [deptId, setDeptId] = useState([]);
  const navigate = useNavigate();
  const userId = JSON.parse(sessionStorage.getItem("AcharyaErpUser"))?.userId;
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    created_date: false,
    dept_name_short: false,
    employeeMobile: false,
  });

  useEffect(() => {
    if (userId) {
      getDeptId(userId);
    }
  }, []);

  useEffect(() => {
    if (deptId?.dept_id) {
      getData(deptId?.dept_id);
    }
    setCrumbs([
      { name: "Service Render", link: "/ServiceRender" },
      { name: "Attend Request" },
    ]);
  }, [deptId]);

  const getData = async (deptId) => {
    setLoading(true);
    await axios
      .get(
        `/api/fetchAllTransportMaintenanceBasedONDeptId?page=0&page_size=${1000000}&sort=created_date`,
      )
      .then((res) => {
        setRows(res.data.data.Paginated_data.content);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const getDeptId = async (userId) => {
    await axios
      .get(`/api/getDeptIdBasedOnUserId/${userId}`)
      .then((res) => {
        setDeptId(res.data.data[0]);
      })
      .catch((error) => console.error(error));
  };

  const columns = [
    {
      field: "id",
      headerName: "Particulars",
      flex: 1,
      renderCell: (params) => (
        <Typography
          variant="subtitle2"
          color="primary"
          sx={{ cursor: "pointer", paddingLeft: 0 }}
        >
          <IconButton
            color="primary"
            onClick={() =>
              navigate("/ServiceRenderTransport/attend", {
                state: { row: params?.row },
              })
            }
          >
            <AddIcon />
          </IconButton>
        </Typography>
      ),
    },
    { field: "type_of_vehicle", headerName: "Type Of Vehicle", flex: 1 },
    { field: "vehicleModel", headerName: "Model", flex: 1 },
    { field: "vehicleNo", headerName: "Vehicle No.", flex: 1 },
    { field: "reporting_place", headerName: "Reporting Place", flex: 1 },
    {
      field: "requesting_from_datetime",
      headerName: "PickUp Date&Time",
      flex: 1,
      renderCell: (params) => (
        <Tooltip
          title={convertToDateandTime(params.row.requesting_from_datetime)}
          arrow
        >
          <Typography
            variant="body2"
            sx={{
              textTransform: "capitalize",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {convertToDateandTime(params.row.requesting_from_datetime)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "requesting_to_datetime",
      headerName: "Droping Date&Time",
      flex: 1,
      renderCell: (params) => (
        <Tooltip
          title={convertToDateandTime(params.row.requesting_to_datetime)}
          arrow
        >
          <Typography
            variant="body2"
            sx={{
              textTransform: "capitalize",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {convertToDateandTime(params.row.requesting_to_datetime)}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "is_round_trip",
      headerName: "Round Trip",
      flex: 1,
      renderCell: (params) => {
        const v = params.row.is_round_trip;
        const yes =
          v === true || v === "true" || v === "yes" || v === 1 || v === "1";
        return yes ? "Yes" : "No";
      },
    },
    {
      field: "return_from_datetime",
      headerName: "Return Date&Time",
      flex: 1,
      renderCell: (params) => {
        const value = params.row.return_from_datetime;
        if (!value) return "";
        return (
          <Tooltip
            title={convertToDateandTime(value)}
            arrow
          >
            <Typography
              variant="body2"
              sx={{
                textTransform: "capitalize",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {convertToDateandTime(value)}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "return_to_datetime",
      headerName: "Arrival Back Date&Time",
      flex: 1,
      renderCell: (params) => {
        const value = params.row.return_to_datetime;
        if (!value) return "";
        return (
          <Tooltip
            title={convertToDateandTime(value)}
            arrow
          >
            <Typography
              variant="body2"
              sx={{
                textTransform: "capitalize",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {convertToDateandTime(value)}
            </Typography>
          </Tooltip>
        );
      },
    },
    { field: "duration", headerName: "Duration", flex: 1 },
    { field: "report_to_person", headerName: "Reporting Person", flex: 1 },
    {
      field: "report_to_person_number",
      headerName: "Reporting Person No.",
      flex: 2,
    },
    { field: "place_of_visit", headerName: "Place Of Visit", flex: 1 },
    {
      field: "purpose",
      headerName: "Purpose",
      flex: 1,
    },
    {
      field: "request_status",
      headerName: "Request Status",
      flex: 2,
    },
    {
      field: "created_username",
      headerName: "Created By",
      flex: 2,
    },
    {
      field: "created_date",
      headerName: "Created Date",
      flex: 2,
      valueGetter: (value, row) =>
        moment(row.created_date).format("DD-MM-YYYY"),
    },
    {
      field: "school_name_short",
      headerName: "Institute",
      flex: 2,
    },
    {
      field: "dept_name_short",
      headerName: "Dept",
      flex: 2,
    },
    {
      field: "employeeMobile",
      headerName: "Requester No.",
      flex: 2,
      valueGetter: (value, row) =>
        row.employeeMobile ? row.employeeMobile : "",
    },
  ];

  return (
    <Box sx={{ position: "relative", mt: 3 }}>
      <Box sx={{ position: "absolute", width: "100%" }}>
        <GridIndex
          rows={rows}
          columns={columns}
          loading={loading}
          columnVisibilityModel={columnVisibilityModel}
          setColumnVisibilityModel={setColumnVisibilityModel}
        />
      </Box>
    </Box>
  );
}

export default AttendServiceTransportRendorIndex;
